import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useModal } from "@/hooks/useVisibility";

export const useDashboardTablePrint = () => {
    const history = useHistory();
    const location = useLocation<{ print?: boolean }>();
    const print = location.state?.print ?? false;
    const printDashboardTable = useModal(print);

    useEffect(() => {
        const handleAfterPrint = () => {
            printDashboardTable.hide();
            history.replace(location.pathname, { ...location.state, print: false });
        };

        window.addEventListener("beforeprint", printDashboardTable.show);
        window.addEventListener("afterprint", handleAfterPrint);

        return () => {
            window.removeEventListener("beforeprint", printDashboardTable.show);
            window.removeEventListener("afterprint", handleAfterPrint);
        };
    }, [printDashboardTable.show]);

    return {
        isPrintDashboardTableVisible: printDashboardTable.isVisible,
        showPrintDashboardTable: printDashboardTable.show,
    };
};
